// Tier 3 mock previews
import type { ReactNode } from 'react'
import { TabsMock } from './Tabs.mock'
import { CheckboxMock } from './Checkbox.mock'
import { ButtonsMock } from './Buttons.mock'
import { FiltersMock } from './Filters.mock'
import {
  FormUtilsMock,
  DatePickerMock,
  DateRangePickerMock,
} from './FormUtils.mock'
import { DialogConfirmMock } from './dialogConfirm.mock'
import { LayoutMock } from './Layout.mock'
import { ColorPickerMock } from './ColorPicker.mock'
import { FileDragDropMock } from './FileDragDrop.mock'
import { SortSelectMock } from './SortSelect.mock'
import { NotFoundMock, NotAuthorizedMock } from './NotFound.mock'
import { TooltipMock } from './Tooltip.mock'
import { BannersMock } from './Banners.mock'
import { PredictedTrafficBadgeMock } from './PredictedTrafficBadge.mock'
import { JsonIntoUlMock } from './JsonIntoUl.mock'
import { ClientDataTableMock } from './DataTables.mock'
import { AttachmentsMock } from './Attachments.mock'
import { FileContainerMock } from './FileContainer.mock'
import { IconsMock } from './Icons.mock'
import { EditorMock } from './Editor.mock'
import { PageMock } from './Page.mock'
import { StagePillMock } from './StagePill.mock'
import { CreatableTagSelectorMock } from './CreatableTagSelector.mock'
import { TextInputMock } from './FormUtilsV2.mock'

export const tier3Mocks: Record<string, () => ReactNode> = {
  Tabs: TabsMock,
  Checkbox: CheckboxMock,
  Buttons: ButtonsMock,
  Filters: FiltersMock,
  FormUtils: FormUtilsMock,
  DatePicker: DatePickerMock,
  DateRangePicker: DateRangePickerMock,
  dialogConfirm: DialogConfirmMock,
  Layout: LayoutMock,
  ColorPicker: ColorPickerMock,
  FileDragDrop: FileDragDropMock,
  SortSelect: SortSelectMock,
  NotFoundCard: NotFoundMock,
  NotAuthorizedCard: NotAuthorizedMock,
  Tooltip: TooltipMock,
  Banners: BannersMock,
  PredictedTrafficBadge: PredictedTrafficBadgeMock,
  'json-into-ul': JsonIntoUlMock,
  // Tables
  ClientDataTable: ClientDataTableMock,
  // Files & Attachments
  Attachments: AttachmentsMock,
  FileContainer: FileContainerMock,
  // Icons & Utilities
  Icons: IconsMock,
  Editor: EditorMock,
  // Layout
  Page: PageMock,
  // Stage & Tags
  StagePill: StagePillMock,
  CreatableTagSelector: CreatableTagSelectorMock,
  // FormUtilsV2
  TextInput: TextInputMock,
}
